import React from "react";

function Footer(props) {
  return (
    <div className="container-fluid py-3 bg-dark footer">
        <div className="d-flex justify-content-center align-items-center">
                <div className="mx-3 social-links">
                    <a
                    href="https://edboardjssstu.in/"
                    className="text-decoration-none"
                    >
                    <i
                        className="fal fa-globe fa-lg text-light"
                    ></i>
                    </a>
                </div>

                <div className="mx-3 social-links">
                    <a
                    href="https://www.instagram.com/the.edboard/"
                    className="text-decoration-none"
                    >
                    <i
                        className="fab fa-instagram fa-lg text-light"
                    ></i>
                    </a>
                </div>

                <div className="mx-3 social-links">
                    <a
                    href="https://www.youtube.com/channel/UCdkOkvTDsl_zQruC5Dx1QYw?sub_confirmation=1"
                    className="text-decoration-none"
                    >
                    <i
                        className="fab fa-youtube fa-lg text-light"
                    ></i>
                    </a>
                </div>

        </div>
    </div>
  );
}

export default Footer;
